<template>
  <b-container fluid id="main-container">
    <div>
      <b-button id="button-addmodel" @click="showModal">
        <span>Add new model</span>
      </b-button>
      <b-table :items="items" :fields="fields">
        <template #cell(id)="data">
            <span class="id-cell">{{data.value}}</span>
        </template>
        <template #cell(name)="data">
          <div v-if="$store.getters.language === 'SLO'">
            <b-form-input v-if="items[data.index].isEdit" type="text" v-model="items[data.index].name_slo"></b-form-input>
            <span v-else>{{items[data.index].name_slo}}</span>
          </div>
          <div v-else>
            <b-form-input v-if="items[data.index].isEdit" type="text" v-model="items[data.index].name"></b-form-input>
            <span v-else>{{items[data.index].name}}</span>
          </div>
        </template>
        <template #cell(short_description)="data">
          <div v-if="$store.getters.language === 'SLO'">
            <b-form-input class="short-description-cell" v-if="items[data.index].isEdit" type="text" v-model="items[data.index].short_description_slo"></b-form-input>
            <span class="short-description-cell" v-else>{{items[data.index].short_description_slo}}</span>
          </div>
          <div v-else>
            <b-form-input class="short-description-cell" v-if="items[data.index].isEdit" type="text" v-model="items[data.index].short_description"></b-form-input>
            <span class="short-description-cell" v-else>{{items[data.index].short_description}}</span>
          </div>
        </template>
        <template #cell(description)="data">
          <div v-if="$store.getters.language === 'SLO'">
            <b-form-textarea class="description-cell" v-if="items[data.index].isEdit" type="text" v-model="items[data.index].description_slo"></b-form-textarea>
            <span class="description-cell" v-else>{{items[data.index].description_slo}}</span>
          </div>
          <div v-else>
            <b-form-textarea class="description-cell" v-if="items[data.index].isEdit" type="text" v-model="items[data.index].description"></b-form-textarea>
            <span class="description-cell" v-else>{{items[data.index].description}}</span>
          </div>
        </template>
        <template #cell(api_url)="data">
            <b-form-input v-if="items[data.index].isEdit" type="text" v-model="items[data.index].api_url"></b-form-input>
            <span class="word-break-cell" v-else>{{data.value}}</span>
        </template>
        <template #cell(api_doc_url)="data">
            <b-form-input v-if="items[data.index].isEdit" type="text" v-model="items[data.index].api_doc_url"></b-form-input>
            <span class="word-break-cell" v-else>{{data.value}}</span>
        </template>
        <template #cell(git_url)="data">
            <b-form-input v-if="items[data.index].isEdit" type="text" v-model="items[data.index].git_url"></b-form-input>
            <span class="word-break-cell" v-else>{{data.value}}</span>
        </template>
        <template #cell(paper_url)="data">
            <b-form-input v-if="items[data.index].isEdit" type="text" v-model="items[data.index].paper_url"></b-form-input>
            <span class="word-break-cell" v-else>{{data.value}}</span>
        </template>
        <template #cell(input_json)="data">
            <b-form-input v-if="items[data.index].isEdit" type="text" v-model="items[data.index].input_json"></b-form-input>
            <span v-else>{{data.value}}</span>
        </template>
        <template #cell(type)="data">
            <b-form-input v-if="items[data.index].isEdit" type="text" v-model="items[data.index].type"></b-form-input>
            <span v-else>{{data.value}}</span>
        </template>
        <template #cell(created_ts)="data">
          <span>{{data.value}}</span>
        </template>
        <template #cell(edit)="data">
          <b-button @click="editRowHandler(data)">
            <span v-if="!items[data.index].isEdit">Edit</span>
            <span v-else>Done</span>
          </b-button>
        </template>
        <template #cell(delete)="data">
          <b-button @click="deleteRow(data)">
            <span>Delete</span>
          </b-button>
        </template>
      </b-table>
      <ModelAdd
        :modal="modal"
        v-show="modal.isModalVisible"
        @close="closeModal"
      />
    </div>
  </b-container>
</template>

<script>
import ModelAdd from './ModelAdd.vue';
export default {
  name: "ModelTable",
  components: {
    ModelAdd
  },
  mounted() {
  this.$http.get(this.$hostname + '/api/model/list')
    .then(response => { 
      this.items = response.data
      this.items = this.items.map(item => ({...item, isEdit: false}));
    })
    .catch(error => {
      console.error(error);
    });
  },
  data() {
    return {
      fields: [
        { key: "id", label: "ID"},
        { key: "name", label: "Name" },
        { key: "short_description", label: "Short Description" },
        { key: "description", label: "Description" },
        { key: "api_url", label: "API URL" },
        { key: "api_doc_url", label: "API doc URL" },
        { key: "git_url", label: "GIT URL" },
        { key: "paper_url", label: "Paper URL" },
        { key: "input_json", label: "Input JSON" },
        { key: "type", label: "type" },
        { key: 'created_ts', label: 'Created TS'},
        { key: 'edit', label: ''},
        { key: 'delete', label: ''}
      ],
      items: [],
      modal: {isModalVisible: false}
    };
  },
  methods: {
      editRowHandler(data) {
        if (this.items[data.index].isEdit) {
          console.log(this.items[data.index])
          this.$http.put(this.$hostname + '/api/model/update', this.items[data.index])
            .then(response => { 
               console.log(response);
            })
            .catch(error => {
              console.error(error);
            });
        }
        this.items[data.index].isEdit = !this.items[data.index].isEdit;
      },
      deleteRow(data) {
        console.log(this.items[data.index])
        this.$http.delete(this.$hostname + '/api/model/' + this.items[data.index].id + '/disable')
          .then(response => { 
             console.log(response);
             this.items.splice(data.index, 1)
          })
          .catch(error => {
            console.error(error);
          });
      },
      showModal() {
        this.modal.isModalVisible = true;
      },
      closeModal() {
        this.modal.isModalVisible = false;
      }
  }
}
</script>

<style>

thead, tbody, tfoot, tr, td, th {
  text-align: left;
  width: 100px;
  vertical-align: middle;
}

.description-cell {
  min-width: 300px;
  display: inline-block;
}

.id-cell {
  max-width: 10px;
  display: inline-block;
}
#button-addmodel {
  margin-left:49%;
  margin-top: 20px;
  margin-bottom: 20px;
}

.word-break-cell {
  word-break: break-all;
}
</style>